import _ from 'lodash';
import featureFlag from '@/api/featureFlag';
import Segment from '@/Segment';

import consts from '../utilities/constants';

const state = {
  featureFlags: {},
  remoteVariables: {},
};

const { FEATURE_FLAG_NAMES: featureFlagNames, REMOTE_VARIABLES: remoteVariables } = consts;

const getters = {
  isStoryMenuOn: state => _isFlagOn(state, featureFlagNames.STORY_MENU),
  showTrackingCategoryChallenge: state => _isFlagOn(state, featureFlagNames.TRACKING_CATEGORY_CHALLENGE),
  keepAmbassadorsInApp: state => _isFlagOn(state, featureFlagNames.JOIN_AMBASSADORS_LINK),
  saveStoryShare: state => _isFlagOn(state, featureFlagNames.SAVE_STORY_SHARE),
  buildsFixedIncomeUsingMLModel: state => _isFlagOn(state, featureFlagNames.FIXED_INCOME_USING_ML_MODEL),
  shouldSharePreviewImages: state => _isFlagOn(state, featureFlagNames.SHARE_PREVIEW_IMAGES),
  showCashflowTrends: state => _isFlagOn(state, featureFlagNames.CASHFLOW_TRENDS),
  showCashflowUpdateIndicators: state => _isFlagOn(state, featureFlagNames.CASHFLOW_UPDATE_INDICATORS),
  moneyBackGuaranteeIsOn: state => _isFlagOn(state, featureFlagNames.MONEY_BACK_GUARANTEE_TEST),
  showPostponedTransactions: state => _isFlagOn(state, featureFlagNames.SHOW_POSTPONED_TRANSACTIONS),
  migrationFromPasswords: state => _isFlagOn(state, featureFlagNames.MIGRATION_FROM_PASSWORDS),
  cashflowUpdateIndicatorsAge: state => parseInt(_getVariableValue(state, remoteVariables.CASHFLOW_UPDATE_INDICATORS_AGE), 10),
  israelBankInterest: state => parseFloat(_getVariableValue(state, remoteVariables.ISRAEL_BANK_INTEREST)),
  inflationRate: state => parseFloat(_getVariableValue(state, remoteVariables.INFLATION_RATE)),
  referralsAbcTest: state => _getVariableValue(state, remoteVariables.REFERRALS_ABC_TEST),
  isFlagIsOn: state => _isFlagOn.bind(this, state),
  planAheadBetaGroup: state => _isFlagOn(state, featureFlagNames.PLAN_AHEAD_BETA_GROUP),
  showEditPredictedIncome: state => _isFlagOn(state, featureFlagNames.SHOW_EDIT_PREDICTED_INCOME),
};

const actions = {
  async init({ commit, dispatch }) {
    const [featureFlagTreatments, remoteVariablesTreatments] = await Promise.all([
      featureFlag.getTreatments(_.values(featureFlagNames)),
      featureFlag.getTreatments(_.values(remoteVariables)),
    ]);
    const featuresTreatments = _.zipObject(_.values(featureFlagNames), featureFlagTreatments);
    const variablesTreatments = _.zipObject(_.values(remoteVariables), remoteVariablesTreatments);
    dispatch('logTreatments', { featuresTreatments, variablesTreatments });
    commit('setFeatureFlags', featuresTreatments);
    commit('setRemoteVariables', variablesTreatments);
  },
  logTreatments({ state }, { featuresTreatments, variablesTreatments }) {
    Segment.trackUserGot('CashflowTrends_FeatureFlagValue', {
      enabled: featuresTreatments[featureFlagNames.CASHFLOW_TRENDS] === 'on',
    });
    Segment.trackUserGot('UpdateIndicators_FeatureFlagValue', {
      enabled: featuresTreatments[featureFlagNames.CASHFLOW_UPDATE_INDICATORS] === 'on',
      indicatorsAge: variablesTreatments[remoteVariables.CASHFLOW_UPDATE_INDICATORS_AGE],
    });
  },
};

// mutations
const mutations = {
  setFeatureFlags(state, featureFlags) {
    state.featureFlags = featureFlags;
  },
  setRemoteVariables(state, variablesTreatments) {
    state.remoteVariables = variablesTreatments;
  },
};

function _isFlagOn(state, featureFlagName) {
  return state.featureFlags[featureFlagName] === 'on';
}

function _getVariableValue(state, variableName) {
  return state.remoteVariables[variableName];
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
